// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2fvxW","header":"PatientBlock_header__2aIQd","label":"PatientBlock_label__Knzc_","option":"PatientBlock_option__MEZCr"};